import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import ReactGA from "react-ga4";
import { AuthProvider } from "./auth/AuthContext";
import Header from "./pages/header/Header";
import HomePage from "./pages/home/Home";
import RegisterPage from "./pages/registration/Register";
import PaymentError from "./DPO/PaymentError";
import PaymentSuccess from "./DPO/PaymentSuccess";
import ProtectedRoute from "./Protected";
import UserDashboard from "./pages/users/UserDashboard";
import Login from "./pages/registration/Login";
import AOS from "aos";
import "aos/dist/aos.css";
import AddStudent from "./pages/registration/AddStudent";
import Unauthorized from "./pages/unauthorised/Unauthorized";
import About from "./pages/about/AboutPage";
import UserProfile from "./pages/profile/UserProfile";
import CotactUs from "./pages/contact/ContactUs";
import DonationsPage from "./pages/donations/DonationsPage";
import Modules from "./pages/modules/index";
import Categories from "./pages/modules/Categories";
import SelectedModules from "./pages/modules/Module";
import ServicePage from "./pages/services/index";
import ServicePages from "./pages/services/ServicesPage";
import MediaPage from "./pages/media/index";
import MediaDisplay from "./pages/media/MediaDisplay";
import GeneralSupport from "./pages/donations/GeneralSupport";
import Project from "./pages/donations/Project";
import SelectedProject from "./pages/donations/ProjectSupport";
import ArrowUp from "./components/ArrowUp";
import RegistrationSuccess from './pages/registration/success';
import Gallery from "./pages/gallary/GalleryPage";
import TermsAndConditions from "./components/TermsAndConditions";

// Initialize AOS
AOS.init({
  duration: 1000,
  once: true,
});

// Initialize Google Analytics with your Measurement ID
// Replace 'G-XXXXXXXXXX' with your actual GA4 Measurement ID
const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || "G-XXXXXXXXXX";
ReactGA.initialize(GA_MEASUREMENT_ID);

// Custom hook to track page views
function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    // Track page view on route change
    ReactGA.send({
      hitType: "pageview",
      page: location.pathname + location.search,
      title: document.title
    });
  }, [location]);
}

function App() {
  // Enable page tracking
  usePageTracking();

  return (
    <AuthProvider>
      <Header />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/get-started" element={<RegisterPage />} />
        <Route path="/payment/success/" element={<PaymentSuccess />} />
        <Route path="/payment/cancel/" element={<PaymentError />} />
        <Route
          element={
            <ProtectedRoute requiredRole={["student", "parent", "self"]} />
          }
        >
          <Route path="/student/portal" element={<UserDashboard />} />
          <Route path="/add-student" element={<AddStudent />} />
        </Route>

        <Route path="/about" element={<About />} />
        <Route path="/about/profile/?" element={<UserProfile />} />
        <Route path="/contact" element={<CotactUs />} />
        <Route path="/donation" element={<DonationsPage />} />
        <Route path="/modules" element={<Modules />} />
        <Route path="/modules/category/:cat/?" element={<Categories />} />
        <Route path="/modules/:category/?" element={<SelectedModules />} />
        <Route path="/services" element={<ServicePage />} />
        <Route path="/services/:service" element={<ServicePages />} />
        <Route path="/media" element={<MediaPage />} />
        <Route path="/media/:uucat" element={<MediaDisplay />} />
        <Route path="/gallery" element={<Gallery />} />

        <Route path="/user/login" element={<Login />} />
        <Route path="/unauthorized" element={<Unauthorized />} />
        <Route path="/donation/support" element={<GeneralSupport />} />
        <Route path="/donation/project/" element={<Project />} />
        <Route path="/project-support" element={<SelectedProject />} />
        <Route path="/registration/success" element={<RegistrationSuccess />} />
      </Routes>
      <ArrowUp />
      <TermsAndConditions />
    </AuthProvider>
  );
}

export default App;